import { memo } from 'react';

interface Props {
  backFillColor: string;
  frontFillColor: string;
  width?: string;
}

const TwitterIcon = ({ backFillColor, frontFillColor, width }: Props) => (
  <span>
    <svg
      width={width || '40px'}
      viewBox="0 0 40 40"
      version="1.1"
      role="img"
      aria-labelledby="twitter-link"
    >
      <title id="twitter-link">Twitter Link</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <rect fill={backFillColor} x="0" y="0" width="40" height="40" rx="20" />
          <g transform="translate(10.000000, 12.000000)" fill={frontFillColor} fillRule="nonzero">
            <path d="M17.9441406,4.05140625 C17.9568359,4.2290625 17.9568359,4.40675781 17.9568359,4.58441406 C17.9568359,10.0031641 13.8325,16.2468359 6.29441406,16.2468359 C3.97207031,16.2468359 1.81472656,15.5742188 0,14.4067578 C0.329960937,14.4448047 0.6471875,14.4575 0.98984375,14.4575 C2.90605469,14.4575 4.67003906,13.8103125 6.07867187,12.70625 C4.27664062,12.6681641 2.76648437,11.4879688 2.24617187,9.86359375 C2.5,9.90164062 2.75378906,9.92703125 3.0203125,9.92703125 C3.38832031,9.92703125 3.75636719,9.87625 4.09898437,9.78746094 C2.22082031,9.40671875 0.812148438,7.75699219 0.812148438,5.76460938 L0.812148438,5.71386719 C1.3578125,6.0184375 1.99238281,6.20878906 2.66492187,6.23414062 C1.56085938,5.49808594 0.837539063,4.24175781 0.837539063,2.82042969 C0.837539063,2.05902344 1.04054688,1.36105469 1.39589844,0.751914062 C3.41367187,3.23921875 6.44667969,4.86355469 9.84765625,5.04125 C9.78421875,4.73667969 9.74613281,4.41945312 9.74613281,4.1021875 C9.74613281,1.84328125 11.5735547,0.003203125 13.8451172,0.003203125 C15.0253125,0.003203125 16.0912891,0.498125 16.8400391,1.29761719 C17.7664062,1.11996094 18.6547266,0.777304688 19.4415625,0.307773437 C19.1369531,1.25957031 18.4897656,2.0590625 17.6395312,2.56664062 C18.4644141,2.47785156 19.2639062,2.249375 19.9999219,1.93214844 C19.4416406,2.74429687 18.7436328,3.46761719 17.9441406,4.05140625 Z" />
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default memo(TwitterIcon);
